import { useState } from 'react';
import { RevealBox, SectionLabel, SectionTitle } from './UI';

const faqs = [
  {
    q: 'Is an online degree valid in India?',
    a: 'Yes. If the program is UGC-DEB approved, the degree is fully valid and legally recognized by the Government of India — for jobs, promotions, and higher studies.',
  },
  {
    q: 'What is the difference between an online degree and distance education?',
    a: 'Distance education uses printed study materials and occasional physical classes. Online degrees are fully digital — live lectures, online exams, and digital assignments. Online is more structured and more accepted by employers today.',
  },
  {
    q: 'Do employers accept online degrees?',
    a: 'Most private sector employers do, as long as the degree is UGC-approved. Companies like TCS, Infosys, Wipro, and HDFC Bank actively hire candidates with recognized online degrees. Always confirm with the specific employer if unsure.',
  },
  {
    q: 'Can I apply for government jobs with an online degree?',
    a: 'In most cases yes, but it depends on the job notification. UGC-approved online degrees are accepted for many central and state government positions. Always read the specific job advertisement carefully before applying.',
  },
  {
    q: 'Is an online MBA as valuable as a regular MBA?',
    a: 'The degree certificate is identical — same university, same seal. The difference is you miss campus life and in-person networking. For career growth, promotions, and salary hikes, an online MBA from a reputed university delivers real results.',
  },
  {
    q: 'Do I need to attend physical classes?',
    a: 'No. For UGC-approved online programs, everything happens digitally — lectures, assignments, exams, and faculty interaction. No commuting, no fixed classroom schedule.',
  },
  {
    q: 'How are exams conducted?',
    a: 'It varies by university. Most conduct online proctored exams from home or at designated exam centres in major cities. Some universities also use internal assessments and project submissions as part of the evaluation.',
  },
  {
    q: 'What is the minimum qualification needed?',
    a: 'For UG programs like BBA or B.Com — you need 10+2 from a recognized board. For PG programs like MBA or M.Com — a Bachelor\'s degree in any stream. Most programs do not require entrance exams or work experience.',
  },
  {
    q: 'Are degrees from private universities valid?',
    a: 'Yes, as long as the university is UGC-DEB approved. NMIMS, Amity, Manipal, and Chandigarh University are all fully recognized. The approval status matters — not whether it is government or private.',
  },
  {
    q: 'Can I do an online degree if I already have a regular degree?',
    a: 'Absolutely. Your existing regular degree makes you eligible to pursue an online postgraduate program like MBA or M.Com. There is no restriction on combining a regular degree with an online one.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(null);

  return (
    <section id="faq" style={{ padding: '100px 6%', background: 'var(--white)' }}>
      <RevealBox style={{ textAlign: 'center', maxWidth: 640, margin: '0 auto 56px' }}>
        <SectionLabel>FAQ</SectionLabel>
        <SectionTitle style={{ maxWidth: '100%', textAlign: 'center' }}>
          Everything You <em style={{ fontStyle: 'italic' }}>Want to Know</em>
        </SectionTitle>
      </RevealBox>

      <div style={{ maxWidth: 780, margin: '0 auto' }}>
        {faqs.map((f, i) => (
          <RevealBox key={i} delay={i * 0.04}>
            <div style={{ borderBottom: '1px solid var(--graylt)' }}>
              <button
                onClick={() => setOpen(open === i ? null : i)}
                style={{
                  width: '100%', background: 'none', border: 'none', cursor: 'pointer',
                  padding: '22px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  gap: 16, textAlign: 'left',
                }}
              >
                <span style={{ fontSize: 16, fontWeight: 600, color: 'var(--navy)', fontFamily: 'DM Sans,sans-serif', lineHeight: 1.4 }}>
                  {i + 1}. {f.q}
                </span>
                <div style={{
                  width: 30, height: 30, minWidth: 30, borderRadius: '50%',
                  background: open === i ? 'var(--yellow)' : 'var(--graylt)',
                  display: 'grid', placeItems: 'center', fontSize: 18,
                  color: open === i ? 'var(--navy)' : 'var(--gray)',
                  transform: open === i ? 'rotate(45deg)' : 'rotate(0)',
                  transition: 'all 0.3s', fontWeight: 300,
                }}>+</div>
              </button>
              <div style={{
                maxHeight: open === i ? 300 : 0,
                overflow: 'hidden', transition: 'max-height 0.35s ease',
              }}>
                <p style={{ fontSize: 15, color: 'var(--gray)', lineHeight: 1.75, paddingBottom: 22 }}>{f.a}</p>
              </div>
            </div>
          </RevealBox>
        ))}
      </div>
    </section>
  );
}